export default "/images/copied.svg?7a43bfb61306b7f0916707229aa74f75";